export default "__VITE_ASSET__DUEC0Eet__"